<div class="containerHome">
    <div class="row containerImage">
        <div class="">
            <img src="../../../../assets/images/backgrounds/main-ganadores.png" alt="">
        </div>
    </div>
    <div class="row containerFooter">
        <div class=" containerImageLogos">
            <img src="../../../../assets/images/backgrounds/logos-footer-2024.jpg" alt="">            
        </div>
        <div class=" containerText">
           <p>
            ROSCARRAZO2025.
            VIGENCIA DE LA PROMOCIÓN: del 20 de diciembre de 2024 a partir de las 0:00:00 al 07 de
             enero de 2025 hasta las 23:59:59, conforme al horario del Centro de la Ciudad de México
             www.roscarrazo.mx,
             COBERTURA GEOGRÁFICA: Ciudad de México, Estado de México, Querétaro, Puebla,
             Hidalgo, Morelos, Guadalajara, Mérida, Tijuana y Cancún.
             INCENTIVOS OFRECIDOS:
             Primer lugar.- Automóvil Susuki blanco 2024 o similar (el modelo y color puede variar de
             acuerdo a disponibilidad),
             Segundo lugar.- Motoneta Italika negra 2025 o similar (el modelo y color puede variar de
             acuerdo a disponibilidad),
             Tercer lugar.- Viaje nacional TDP para 2 personas o similar (el destino puede variar de
             acuerdo a disponibilidad),
             Cuarto lugar.- Iphone 15 PRO de 256 GB o similar (el modelo y color puede variar de
             acuerdo a disponibilidad),
             Quinto lugar.- Apple MacBook Air 256 GB o similar (el modelo y color puede variar de
             acuerdo a disponibilidad),
             Sexto lugar.- TV Samsung 65 Pulgadas 4K Ultra o similar (el modelo y color puede variar
             de acuerdo a disponibilidad),
             Séptimo lugar.- Sala modular Verzza o similar (el modelo y color puede variar de acuerdo a
             disponibilidad),
             Octavo lugar.- Refrigerador Top Mount 9 pies o similar (el modelo y color puede variar de
             acuerdo a disponibilidad),
             Noveno lugar.- AirPods max o similar (el modelo y color puede variar de acuerdo a
             disponibilidad) y Décimo lugar.- Apple Watch SE 40 mm o similar (el modelo y color puede
             variar de acuerdo a disponibilidad),.
             Mecánica: Durante la vigencia de la promoción por cada $99.00 (noventa y nueve pesos 00/100
             m.n.) de compra en las tiendas que usan las marcas PASTELERIAS ESPERANZA, ESPERANZA,
             BONPANE, SANTO GALLO y ROZT, y queseencuentran descritas en www.roscarrazo.mx, recibirá
             un ticket de participación; para la promoción debe responder a la pregunta que se encuentra ubicada
             físicamente en el ticket de participación. Para participar en la promoción debe depositar el ticket de
             participación en cualquiera de las urnas de las sucursales participantes, debe proporcionar los datos
             solicitados y contestar a la pregunta señalada en el talón. El participante deberá ser mayor de 18
             años con capacidad de ejercicio. La asignación de los incentivos, se realizará de manera
             consecutiva.
             El día 14 de enero de 2025, se realizará la publicación de los acreedores al incentivo en
             www.roscarrazo.mx. El día 17 de enero de 2025 se realizará la entrega de los incentivos. Bases e
             información general en el sitio web oficial de la promoción: www.roscarrazo.mx, teléfono y correo de
             atención para dudas y aclaraciones: (55) 6285 0400 ext. 9111, dentro de un horario de atención de
             lunes a viernes de 10:00 a 17:00 horas o mediante correo electrónico contacto2@esperanza.mx,
             RESPONSABLE DE LA PROMOCIÓN Y ORGANIZADORA: Esperanza Trico Camarones, S.A. de
             C.V., con domicilio para todo lo relacionado en las presentes bases en Av. Año de Juárez 289, Col.
             Granjas de San Antonio, Alcaldía Iztapalapa, C.P. 09070, Ciudad de México
           </p>
        </div>
    </div>
</div>